import { render, staticRenderFns } from "./fromBDD.vue?vue&type=template&id=0769bb94"
import script from "./fromBDD.vue?vue&type=script&lang=js"
export * from "./fromBDD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports